module.exports = __webpack_public_path__ + "img/battery-img.cd582cbe.svg";